import Result from "@/core/common/Result";
import {
  IListarContatatosResponse,
  InsightConfiguracaoGateway,
  ISalvarContatoParams,
  ISalvarContatoResponse,
  ISalvarInsightConfiguracaoResponse,
  TGerarRelatorioAgenteDRERequest,
  TLimparRelatorioAgenteDRERequest,
  TConfigurarInsightsIARequest
} from "./InsightConfiguracaoGateway";
import { inject } from "inversify";
import { FinancasDevHttpDi } from "@/core/services/FinancasDevHttp";
import { DITypes } from "@/core/@types/types";
import { type HttpClient } from "@/core/services/protocols/types";
import { type IFinancasDevHttp } from "@/core/services/FinancasDevHttp";
import { IDefaultInsightsIAResponse } from "../../../views/agenteDeDRE/services/InsightsAIDreGateway";

export class InsightConfiguracaoGatewayAdapter implements InsightConfiguracaoGateway {
  @inject(DITypes.INDICADORES_HTTP_CLIENT)
  private httpClientIndicadores!: HttpClient;

  @inject(FinancasDevHttpDi)
  private financasDevHttp!: IFinancasDevHttp;

  async configurar(
    payload: TConfigurarInsightsIARequest
  ): Promise<Result<ISalvarInsightConfiguracaoResponse>> {
    const response =
      await this.httpClientIndicadores.post<ISalvarInsightConfiguracaoResponse>(
        {
          url: "/agente-dre/AgenteDRE/v1/configuracao-relatorio",
          body: payload
        }
      );

    if (response.statusCode !== 200) {
      return Result.fail("Erro ao salvar configuração");
    }

    //TODO: REMOVER MENSAGEM DE SUCESSO, DEIXAR SOMENTE QUANDO EDITAR
    return Result.ok({
      success: true,
      message: "Configuração salva com sucesso"
    });
  }

  async limparRelatorio(
    payload: TLimparRelatorioAgenteDRERequest
  ): Promise<Result<boolean>> {
    const response = await this.httpClientIndicadores.post<
      IDefaultInsightsIAResponse<boolean>
    >({
      url: "/agente-dre/AgenteDRE/v1/limpar-relatorio",
      body: payload
    });

    if (response.statusCode !== 200) {
      return Result.fail("Erro ao excluir relatório");
    }

    if (response.body?.code !== 200) {
      return Result.fail(
        response.body?.errors?.[0]?.message || "Erro ao excluir relatório"
      );
    }

    return Result.ok(response.body?.result ?? true);
  }

  async gerarRelatorio(
    payload: TGerarRelatorioAgenteDRERequest
  ): Promise<Result<boolean>> {
    const response = await this.httpClientIndicadores.post<
      IDefaultInsightsIAResponse<boolean>
    >({
      url: "/agente-dre/AgenteDRE/v1/desenvolvedor/gerar-relatorio",
      body: payload
    });

    if (response.statusCode !== 200) {
      return Result.fail("Erro ao gerar relatório");
    }

    if (response.body?.code !== 200) {
      return Result.fail(
        response.body?.errors?.[0]?.message || "Erro ao gerar relatório"
      );
    }

    return Result.ok(response.body?.result ?? true);
  }

  async listarContatatos(): Promise<Result<IListarContatatosResponse[]>> {
    const response = await this.httpClientIndicadores.get<
      IDefaultInsightsIAResponse<IListarContatatosResponse[]>
    >({
      url: "/agente-dre/AgenteDRE/v1/listar-contatos"
    });

    if (response.statusCode !== 200) {
      return Result.fail("Erro ao salvar configuração");
    }

    return Result.ok(response.body?.result);
  }

  async salvarContato(
    payload: ISalvarContatoParams
  ): Promise<Result<IDefaultInsightsIAResponse<ISalvarContatoResponse>>> {
    const response = await this.httpClientIndicadores.post<
      IDefaultInsightsIAResponse<ISalvarContatoResponse>
    >({
      url: "/agente-dre/AgenteDRE/v1/salvar-editar-contato",
      body: payload
    });

    if (response.statusCode !== 200) {
      return Result.fail("Erro ao salvar configuração");
    }

    return Result.ok(response.body);
  }
}
